import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es para principiantes?',
    a: 'Sí, desde cero.'
  }, {
    q: '¿Necesito equipamiento?',
    a: 'No. Opcional.'
  }, {
    q: '¿Cuánto tiempo por día?',
    a: '20–40 minutos.'
  }, {
    q: '¿Funciona si tengo poco tiempo?',
    a: 'Sí. Está pensado para eso.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-80">
      <div className="text-center mb-12" data-id="element-81">
        <h2 className="font-display text-3xl md:text-4xl font-bold flex items-center justify-center gap-3 text-gray-900" data-id="element-82">
          <span data-id="element-83">❓</span> LO QUE MÁS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-84">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-pink-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-85">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-86">
              <span className="font-bold text-lg text-gray-900" data-id="element-87">{faq.q}</span>
              <ChevronDown size={20} className={`text-brand-accent transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-88" />
            </button>
            <AnimatePresence data-id="element-89">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-90">
                  <div className="px-6 pb-5 text-gray-500 text-lg" data-id="element-91">{faq.a}</div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}